import React, { memo, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { LottieGif } from '@Sage/ssm-web5';
import { Spacer, Text, useTheme } from '@Sage/hoi-poi-ui';
import AbsoluteLoader from 'components/AbsoluteLoader';
import SageMobileLogo from 'components/SageMobileLogo';
import useLoginLiterals from 'utils/literals/useLoginLiterals';
import { logEvent } from 'utils/tracking';
import invitationErrorLottie from './invitationErrorLottie.json';

import './styles.scss';

const SageMobileError = memo(() => {
    const theme = useTheme();
    const { code } = useParams();
    const isFirstRender = useRef(true);

    const { loading: literalsLoading, getLiteral } = useLoginLiterals();
    const literals = useMemo(() => {
        let keys = {
            title: 'label_invitation_expired_error_screen_title',
            description: 'label_invitation_expired_error_screen_explanation',
        };

        switch (code) {
            case '401':
                if (isFirstRender.current) {
                    logEvent({
                        event: 'settings',
                        submodule: 'users',
                        functionality: 'exceededAvailableSeats',
                    });
                    isFirstRender.current = false;
                }
                keys = {
                    title: 'label_invitation_error_no_licenses_title',
                    description: 'label_invitation_error_no_licenses_explanation',
                };
                break;
            default:
                break;
        }

        return {
            title: getLiteral(keys.title),
            description: getLiteral(keys.description),
        };
    }, [code, getLiteral]);

    if (literalsLoading) {
        return (
            <div className="sage-mobile-error">
                <AbsoluteLoader size="massive" />
            </div>
        );
    }

    return (
        <div className="sage-mobile-error">
            <div className="sage-mobile-error__content">
                <SageMobileLogo />
                <Spacer y={4} />
                <Text type="h3" bold>
                    {literals.title}
                </Text>
                <Spacer y={2} />
                <Text type="body" color={theme.colors.textLight.secondary}>
                    {literals.description}
                </Text>
                <Spacer y={2} />
                <div className="sage-mobile-error__gif">
                    <LottieGif src={invitationErrorLottie} width="250px" height="250px" />
                </div>
            </div>
        </div>
    );
});

export default SageMobileError;
